import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CategoryInformationService } from '../../../../../core/services/category-information.service';
import { UsefulInformationService } from '../../../../../core/services/useful-information.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { FormsModule } from '@angular/forms';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { BrowserModule } from '@angular/platform-browser';
import { HeaderComponent } from '../../../layout/includes/header/header.component';


@Component({
    selector: 'app-useful-information',
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        LoadingComponent,
        SampleSearchPipe,
        NgSelectModule,
        HeaderComponent,
        NgxPaginationModule,
        AngularEditorModule
    ],
    templateUrl: './useful-information.component.html',
    styleUrls: ['./useful-information.component.css']
})
export class UsefulInformationComponent {
  buttonsPermission :any|undefined;
  search_text=""
   ays:any[] =[]
   periods:any[] =[]
   roles:any[] =[]
   data:any[] =[]
   categories:any[] =[]
   cibles:any[] =[]
   selected_data:any;
   modalOption:any; 
   isDtInitialized:boolean = false
   is_active=null
   loading=false
   tag="admin-useful-informations"
   pg={
     pageSize:10,
     p:0,
     total:0
   }
   role:any
   user:any
   fileInput:any

 
   constructor(
     private ciService:CategoryInformationService,
     private uiService:UsefulInformationService,
     private toastrService:ToastrService,
       config: NgbModalConfig,
       private lsService:LocalStorageService,
     private modalService: NgbModal) {
      config.backdrop = 'static';
      config.keyboard = false;
      }
 
 
   ngOnInit(): void {
    this.cibles=this.lsService.get(GlobalName.features).information_types
     this.init()
      this.getActions()
   }
 
   init(){
     this.getAll()
     this.getCategories()
   }
 
  
 
  
 
   getAll(){
     this.uiService.getAll().subscribe((res:any)=>{
       this.data=res.data
       this.pg.pageSize=10
       this.pg.p=0
       this.pg.total=res.data.length
       this.modalService.dismissAll()
     },
     (err:any)=>{
 AppErrorShow.showError("Gestion des informations utiles ",err)
     })
   }

   getCategories(){
     this.ciService.getAll().subscribe((res:any)=>{
       this.categories=res.data
     },
     (err:any)=>{
 AppErrorShow.showError("Gestion des informations utiles ",err)
     })
   }
 
 
   store(value:any){
     this.loading=true

     var d1 = new Date(value.publish_start_date)
     var d2 = new Date(value.publish_end_date)
     if(d2 < d1){
      this.toastrService.error("La date d'arrêt de publication doit ête postérieur à la date de publication")
      return ;
     } 

     let formData= new FormData()
     for (const key in value) {
       if (Object.prototype.hasOwnProperty.call(value, key)) {
         const element = value[key];
         formData.append(key,element)
       }
     }
 
     if (this.fileInput!=undefined) {
         formData.append("filename",this.fileInput)
     }
     
     this.uiService.store(value).subscribe((res:any)=>{
       this.loading=false
 
         this.toastrService.success(res.message)
         this.getAll()
 
     },
     (err:any)=>{
       this.loading=false
 
       console.log(err)
         AppErrorShow.showError("Gestion des informations utiles ",err)
 
     })
   }
   update(value:any){

    var d1 = new Date(value.publish_start_date)
    var d2 = new Date(value.publish_end_date)
    if(d2 < d1){
     this.toastrService.error("La date d'arrêt de publication doit ête postérieur à la date de publication")
     return ;
    } 
    
     this.loading=true
 
     this.uiService.update(this.selected_data.id,value).subscribe((res:any)=>{
       this.loading=false
 
         this.toastrService.success(res.message)
         this.getAll()
     },
     (err:any)=>{
       this.loading=false
 
       console.log(err)
         AppErrorShow.showError("Gestion des informations utiles ",err)
 
     })
   }
   delete(){
     if(!this.verifyIfElementChecked()) return ;
     let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
     confirmed.then((result:any)=>{
        if (result.isConfirmed) {
     this.uiService.delete(this.selected_data.id).subscribe((res:any)=>{
         this.toastrService.success(res.message)
         this.getAll()
     },
     (err:any)=>{
       console.log(err)
         AppErrorShow.showError("Gestion des informations utiles ",err)
 
     })
   }
 })
   }
   checked(el?:any){
     this.selected_data=el;
     this.is_active=el.is_active
   }
   verifyIfElementChecked(){
     console.log(this.selected_data)
     if (this.selected_data==null) {
       this.toastrService.warning("Aucun élément selectionné");
       return false;
     }
     return true;
   }
 
 
 
   dismiss(){
     this.modalService.dismissAll()
   }
 
   add(content:any){
     this.modalService.open(content,{size:'lg'});
   }
 
 
   show(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.modalOption={centered:false,size:"lg"}
     this.modalService.open(content,{size:'lg'});
   }
 
   edit(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.modalService.open(content,{size:'lg'});
 
   }

   upload(ev:any){
    if (ev?.target.files.length!=0) {
      this.fileInput=ev?.target.files[0]
    }
   }
 
   setStatus(value:any){
 
     this.toastrService.warning("Opération en cours")
   
         this.uiService.setState(this.selected_data.id,value).subscribe((res:any)=>{
           this.toastrService.success(res.message)
           this.getAll()
       },
       (err:any)=>{
         console.log(err)
           AppErrorShow.showError("Gestion des informations utiles ",err)
 
       })
   }
 
   getPage(event:any){
     this.pg.p=event
   }

   
 
   getActions(){
     // this.buttonsPermission = {
     //   show:AppActionCheck.check(this.tag,'Consultation'),
     //   add:AppActionCheck.check(this.tag,'ajout'),
     //   edit:AppActionCheck.check(this.tag,'edition'),
     //   delete:AppActionCheck.check(this.tag,'suppression'),
     //   status:AppActionCheck.check(this.tag,'statut')
     // };
     this.buttonsPermission={
       show:true,
       add:true,
       edit:true,
       delete:true,
       status:true,
     }
   }
}
